import moment from 'moment'

export function stringContains(string, findInString) {
    return string.indexOf(findInString) >= 0
}


export function importCSV(stateHandler) {
    let formData = new FormData()
    let input = document.createElement('input')
    input.type = 'file'
    input.onchange = async _ => {
        const selectedFile = input.files
        formData.append(`doc`, selectedFile[0], selectedFile[0].name)
        if (selectedFile[0].type === 'text/csv') {
            await stateHandler(formData)
        } else {
            return 'Файл должен быть в формате CSV.'
        }
    }
    input.click()
}

export function roleIdToString(roleId) {

    switch (roleId) {
        case 2:
            return 'Мендежер системы'
        case 3:
            return 'Организация'
        case 4:
            return 'Медицинский центр'
        case 5:
            return 'Удостоверяющий центр'
        case 6:
            return 'Доктор'
        case 7:
            return 'Пациент'
        case 9:
            return 'Кабинетный лаборант'

        case 10:
            return 'Машинный лаборант'
    }

}

export function stringBoolParser(boolString = '') {
    if (typeof boolString === 'string') {
        boolString.toLowerCase()
        if (boolString === 'true') return true
        if (boolString === 'false') return false
    }

    return boolString
}


export function formatDate(date, dateInput, dateOutput) {
    if (date) return moment(date, dateInput || '').format(dateOutput || 'DD-MM-YYYY')
    return ""
}

export function ucFirst(str) {
    if (!str) return ""
    return (str[0].toUpperCase() + str.slice(1)).trim()
}

export function trim(str) {
    if (!str) return str;
    return str.replace(/^\s+/g, '');
}

export function cleanPhoneMask(phone = '') {
    return phone
        .replaceAll('_', '')
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll('-', '')
        .replaceAll(' ', '')
}

export function isWaiting(result) {
    let value
    if (result?.match(/Без патологических изменений/i)) {
        value = false
    } else if (result?.match(/Норма/i)) {
        value = false
    } else if (result?.match(/вызов/i)) {
        value = false
    } else if (result?.match(/ожидание/i)) {
        value = true
    } else {
        value = true
    }
    return value
}

export function isArray(array) {
    if (array?.length > 0) {
        return array
    } else {
        return []
    }

}